import { inject, Injectable } from "@angular/core";
import { defaultEbenTaskQueryRepresentation, EbenTaskQueryRepresentation, EbenTaskQueryRepresentationKeys } from '@alf-nx-workspace/eben/interfaces';
import { Router } from "@angular/router";
import { WORKFLOW_VARIABLE_MAPPING } from './workflow.service';

@Injectable({providedIn: 'root'})
export class FlowTaskListService {

  readonly workflowVariables = inject(WORKFLOW_VARIABLE_MAPPING);
  readonly router = inject(Router);

  public onQueryChange(query: EbenTaskQueryRepresentation) {
    if (query.searchableVariablesQuery) {
      query.searchableVariables = (<string[]>this.workflowVariables).reduce((accumulator, value) => accumulator.concat(value), []);
    } else {
      delete query.searchableVariables;
    }

    // remove all query parameters that are null
    for (const key in query) {
      if (query[key] === null) {
        delete query[key];
      }
    }

    // Remove default query params from url
    const modifiedQueryParams = {};
    for (const key in query) {
      if(key === EbenTaskQueryRepresentationKeys.searchableVariables) continue;
      if (defaultEbenTaskQueryRepresentation[key] != query[key]) {
        modifiedQueryParams[key] = query[key];
      }
    }

    this.router.navigate([], {queryParams: modifiedQueryParams});
    return query;
  }
}
